<template>
  <!-- :bodyStyle="{paddingTop:'10px'}" -->
  <a-card :bordered="false" :headStyle="{borderBottom:'0px',fontSize:'18px',paddingLeft:'24px'}">
    <search-page-view
      ref="table"
      rowKey="travelMadeReserveId"
      :columns="columns"
      :enableSearch="false"
      :queryParams="queryParams"
      requestType="get"
      params-path="orderCustomMade/getReserveOrderCustomMadeList"
      base-key="orderUrl"
    >

      <template slot="statusSlot" slot-scope="data">
        <span>{{ data.text | bookstatusFilter }}</span>
      </template>
      <div slot="action" slot-scope="data">
        <a @click="onBatch(data.record.travelMadeReserveId)">更新状态</a>
      </div>
    </search-page-view>
    <!-- 弹窗 -->
    <a-modal title="预约状态更新"
             :visible="confirmVisible"
             @ok="handleBookBtns"
             :confirmLoading="confirmLoading"
             @cancel="handleCancel"
    >
      <detail-list :col="2">
        <detail-list-item term="称呼">{{ formData.travelMadeReserveName }}</detail-list-item>
        <detail-list-item term="目的地">{{ formData.travelMadeReserveDestination }}</detail-list-item>
        <detail-list-item term="手机号">{{ formData.travelMadeReserveMobile }}</detail-list-item>
        <detail-list-item term="预算范围">{{ formData.travelMadeReserveBudget }}</detail-list-item>
        <detail-list-item term="计划日期">{{ formData.travelMadeReserveDate }}</detail-list-item>
        <detail-list-item term="和谁去" v-if="formData.travelMadeReserveType == '个人'">
          {{ formData.travelMadeReserveYuWhoGo }}
        </detail-list-item>
        <detail-list-item term="计划天数">{{ formData.travelMadeReserveDays }}</detail-list-item>
        <detail-list-item :term="formData.travelMadeReserveType == '个人'?'偏爱主题：':'出游目的'">
          {{ formData.travelMadeReserveTravelTheme }}
        </detail-list-item>
        <detail-list-item term="出游类型">{{ formData.travelMadeReserveType }}</detail-list-item>
      </detail-list>
      <detail-list :col="1">
        <detail-list-item term="预约状态">
          <a-select v-model="formData.travelMadeReserveStatus" placeholder="请选择" allowClear style="width:200px;">
            <a-select-option :value="0">待沟通</a-select-option>
            <a-select-option :value="1">沟通中</a-select-option>
            <a-select-option :value="2">已结束</a-select-option>
            <a-select-option :value="3">已成交</a-select-option>
          </a-select>
        </detail-list-item>
        <a-textarea v-model="formData.travelMadeReserveRemarks" placeholder="请输入备注" :maxLength="300" :rows="4"/>
      </detail-list>

    </a-modal>
  </a-card>
</template>

<script>
export default {
  name: 'BookList',
  data() {
    return {
      confirmLoading: false,
      confirmVisible: false,
      queryParams: {},
      columns: [
        {
          title: '预约ID',
          dataIndex: 'travelMadeReserveId'
        },
        {
          title: '手机号码',
          dataIndex: 'travelMadeReserveMobile'
        },
        {
          title: '称呼',
          dataIndex: 'travelMadeReserveName'
        },
        {
          title: '提交时间',
          dataIndex: 'travelMadeReserveCreateTime'
        },
        {
          title: '状态',
          dataIndex: 'travelMadeReserveStatus',
          scopedSlots: { customRender: 'statusSlot' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '120px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      formData: {}
    }
  },
  mounted() {

  },
  activated() {
    this.getLogUtils().logWithTag('activated', 'activated')
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'BookList', title: '预约列表' },
      { name: 'CustomOrderList', title: '订单管理' }
    ])
  },
  methods: {
    onBatch(id) {
      this.confirmVisible = true
      this.getLogUtils().logWithTag('onBatch', id)
      this.getHttpServices().getOrderService().get('orderCustomMade/getReserveOrderCustomMadeInfo/' + id).then(res => {
        this.getLogUtils().logWithTag('==getReserveOrderCustomMadeInfo==', res)
        this.formData = res
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    handleCancel() {
      this.confirmVisible = false
    },
    handleBookBtns() {
      this.confirmLoading = true
      let params = new Object()
      params.travelMadeReserveId = this.formData.travelMadeReserveId
      params.travelMadeReserveRemarks = this.formData.travelMadeReserveRemarks
      params.travelMadeReserveStatus = this.formData.travelMadeReserveStatus
      this.getHttpServices().getOrderService().post('orderCustomMade/updateOrderCustomMadeInfo', params).then(res => {
        this.$message.success('更新状态成功')
        this.confirmVisible = false
        this.$refs.table.refresh(true)
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.confirmLoading = false)
    }

  }

}
</script>
<style scoped lang="less">

</style>